// extracted by mini-css-extract-plugin
export default {"secondary":"Button_secondary__Pj61b"};